import { Publication, PublicationIdentifierType } from '../types';

// Tipos de identificador de producción académica (PA1). El valor es lo que se
// guarda; la etiqueta es lo que se muestra al usuario.
export const IDENTIFIER_TYPES: Array<{
  value: PublicationIdentifierType;
  label: string;
}> = [
  { value: 'DOI', label: 'DOI' },
  { value: 'ISBN', label: 'ISBN' },
  { value: 'ROOT', label: 'ROOT' },
  { value: 'other', label: 'Otro' },
];

export const identifierTypeLabel = (
  type?: PublicationIdentifierType | null
): string => IDENTIFIER_TYPES.find((t) => t.value === type)?.label || 'Otro';

// A3 (sync 2026-07-13): CPA entrega el DOI a veces como identificador pelado
// ("10.1234/abcd") y a veces como URL ya formada ("https://doi.org/10.1234/abcd").
// Esta normalización maneja AMBOS casos: si ya es URL se usa tal cual; si no,
// se concatena la base genérica https://doi.org/.
// NOTA dev backend: implementar esta misma lógica al consumir la API de CPA
// (acordado en la sync 2026-07-13, 00:34:43–00:38:40).
export const doiUrl = (value: string): string => {
  const v = value.trim();
  if (/^https?:\/\//i.test(v)) return v;
  if (/^(www\.)?doi\.org\//i.test(v)) return `https://${v.replace(/^www\./i, '')}`;
  return `https://doi.org/${v}`;
};

// PA3/PA4: enlace de acceso a la evidencia. Prioriza el accessUrl explícito
// (carga manual); si no, deriva el link para un DOI vía doiUrl (dual: valor
// pelado o URL completa). Devuelve null si no hay forma de enlazar (p. ej.
// ISBN/ROOT sin URL).
export const getPublicationLink = (pub: Publication): string | null => {
  if (pub.accessUrl && pub.accessUrl.trim() !== '') return pub.accessUrl.trim();
  if (pub.identifierType === 'DOI' && pub.identifierValue) {
    return doiUrl(pub.identifierValue);
  }
  return null;
};

// Clave estable para deduplicar publicaciones (valor de identificador o, si no
// hay, el enlace/título).
export const publicationKey = (pub: Publication): string =>
  (pub.identifierValue || pub.accessUrl || pub.title || '').trim();
